<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.appareil.appareil')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
        <template v-slot:close>
            <template v-if="selected">
                <div class="font-bold">{{selected[0].value.description}}</div>
                <div class="text-xs font-light">{{selected[0].value['Modele']}}</div>
            </template>
        </template>
        <template v-slot:open>
            <sav-spinner v-if="loading" :size="10" />
            
            <div @click="displayHelp = !displayHelp" v-if="ratingLabel" class="p-5 mb-5 duration-200 bg-gray-100 cursor-pointer hover:bg-gray-200 rounded-xl">
                <div class="flex items-center justify-between">
                    <div class="flex items-center">
                        <img class="h-24 mr-4 rounded-xl" src="https://disticloudfiles.net/img/savinfo/default/device_help.png" alt="">
                        <div>
                            <h2 class="text-xl font-bold">{{$t('form.appareil.comment_trouver_mon_modele')}}</h2>
                        </div>
                    </div>
                    <div class="mr-4 text-2xl">
                        <div v-show="!displayHelp">
                            <i class="fas fa-chevron-down"></i>
                        </div>
                        <div v-show="displayHelp">
                            <i class="fas fa-chevron-up"></i>
                        </div>
                    </div>
                </div>
                <template v-if="displayHelp">
                    <img class="w-full my-5 rounded-xl xl:w-1/2" :src="ratingLabel" alt="">
                </template>
            </div>
            <sav-form v-if="data" :data-src="data" :callback="end" :id="$options.name" />
            <!-- Modal request -->
            <modal :name="'request-' + requestModalParams.libelle">
                <sav-request-modal :displayName="requestModalParams.label" :libelle="requestModalParams.libelle" @close="hideRequestModal" />
            </modal>
            <button @click="displayRequestModal" class="block ml-auto mt-4 text-gray-900 font-light border border-gray-200 p-1.5 px-3 text-xs rounded-xl hover:bg-gray-100 duration-200">
                <i class="fa-solid fa-circle-question mr-0.5"></i> {{requestModalParams.label}} {{$t('form.marque.introuvable')}}
            </button>
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'device',
    extends: FormCardExtension,

    watch: {
        open: function(value) {
            if (value === true) {
                this.data[0].value = null
            }
        }
    },

    data() {
        return {
            ratingLabel: null,
            displayHelp: false,
        }
    },

    computed: {
        userIsAuth() {
            return !this.$crypto.decrypt(localStorage.getItem('client_id'))
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.nextBlock = await this.getNextBlock()
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
            }
            
            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Get api data
            let response = await apiService.post('getapp', {
                id_group: this.$formTool.getFormData('category').id,
                marque: this.$formTool.getFormData('brand').label,
                // id_fam: this.getBlock('family').result ? this.getBlock('family').result.id : null,
                id_categ: this.$formTool.getFormData('subcategory') ? this.$formTool.getFormData('subcategory').id : null,
            })
            let devices = response.data.posts.post

            devices = devices.map(item => {
                if (item.description) {
                    item.description = item.description.replace(/[\u0096]/g, ''); // ou '' si tu veux le supprimer
                }
                return item;
            })

            // Set Rating label
            if (devices[0].rating_label && devices[0].rating_label != 0) {
                this.ratingLabel = devices[0].rating_label
            }

            this.data = [
                {
                    type: 'sav-select',
                    options: {
                        label: 'modelDescription',
                        values: devices.map(device => ({
                            ...device,
                            modelDescription: device.rating_label ? device.description : device['Modele'],
                            moreData: device.rating_label ? device['Modele'] : device.description,
                        }))
                    }
                }
            ]

            // Set Modal Requests
            this.requestModalParams = {
                label: this.$t('form.appareil.modele'),
                libelle: 'appareil'
            }
            
            this.loading = false
        },

        async end(callbackData) {
            if (!callbackData[0].value)
                return
            let emptyValues = callbackData.find(element => element.value == null)
            if (!emptyValues) {
                let saveValue = JSON.parse(JSON.stringify(callbackData))
                delete saveValue[0].options.values
                this.$formTool.addFormData(this.$options.name, saveValue)

                this.nextBlock = await this.getNextBlock()
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                this.selected = JSON.parse(JSON.stringify(callbackData))
            }
        },

        async getBdc() {
            let responseBdc = await apiService.post('getbdc', {
                id_app: this.$formTool.getFormData(this.$options.name)[0].value.id
            })
            return responseBdc.data.posts
        },
        async getBdc2() {
            let responseBdc = await apiService.post('getbdc2', {
                id_app: this.$formTool.getFormData(this.$options.name)[0].value.id
            })
            return responseBdc.data.posts
        },

        async getNextBlock() {
            // Check user authenticated
            if (this.userIsAuth) {
                return 'login'
            }

            return this.$formTool.blockData(this.$options.name).next
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/product/DeviceCard.vue